module.exports = __webpack_public_path__ + "media/illustrations/people_happy-6fd94c41.png";